import React, { useState, useEffect, useContext } from 'react';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Box, Typography,Button,CircularProgress,List,ListItem,ListItemText ,IconButton,Collapse,Divider,
    Modal,TextField,FormControl,MenuItem,Select,InputLabel
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { LoadToCosmos,SendToCosmos, DeleteToCosmos} from './SendToCosmos';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ModeContext } from './ModeContext';

const SettingsUser = () => {
    console.log('MainAdmin:start')
    const { loginInfo } = useContext(ModeContext);
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedCompanies, setExpandedCompanies] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({});
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    
    //モーダル用
    const [editType, setEditType] = useState('');
    const [compId, setCompId] = useState('');
    const [compName, setCompName] = useState('');
    const [userId, setUserId] = useState('');
    const [userName, setUserName] = useState('');
    const [authorityId, setAuthorityId] = useState('');
    const [groupId, setGroupId] = useState('');

    //DB読み込み
    const fetchUsers = async () => {
        try {
            const uppayload = {
                id: 'all',
                container: "con-concierge-user",
            };
            const item = await LoadToCosmos(uppayload);
            
            // HQ権限の場合は自分の企業のユーザーのみに絞り込む
            const users = loginInfo.authorityId === 'HQ'
                ? item.item.filter(user => user.compId === loginInfo.compId)
                : item.item;

            // 顧客 → グループ → ユーザーの3階層構造に変換
            const groupedData = users.reduce((acc, user) => {
                const compId = user.compId;
                const groupId = user.groupId || 'グループなし';
                
                if (!acc[compId]) {
                    acc[compId] = {
                        compName: user.compName,
                        groups: {}
                    };
                }
                
                if (!acc[compId].groups[groupId]) {
                    acc[compId].groups[groupId] = [];
                }
                
                acc[compId].groups[groupId].push(user);
                return acc;
            }, {});

            console.log('groupedData', groupedData);
            setUserList(groupedData);

        } catch (error) {
            console.error("データ取得エラー:", error);
        } finally {
            setLoading(false);
        }
    };

    // CosmosDBからユーザー情報を取得
    useEffect(() => {

        fetchUsers();
    }, []);

    // 顧客の開閉処理
    const handleToggleCompany = (compId) => {
        setExpandedCompanies((prevState) => ({
            ...prevState,
            [compId]: !prevState[compId],
        }));
    };

    // グループの開閉処理
    const handleToggleGroup = (compId, groupId) => {
        const key = `${compId}-${groupId}`;
        setExpandedGroups((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    // 編集モーダルの開閉
    const  handleEditClick = (type,user,compId,compName,groupId) => {
        switch (type) {
        case 'AddGroup':
            setEditType('AddGroup');
            setCompId(compId);
            setCompName(compName);
            setUserId('');
            setUserName('');
            setAuthorityId('');
            setGroupId(groupId === 'グループなし' ? '' : groupId);
            setIsEditModalOpen(true);
            break;

        case 'AddCompany':
            setEditType('AddCompany');
            setCompId(compId);
            setCompName(compName);
            setUserId('');
            setUserName('');
            setAuthorityId('');
            setGroupId('');
            setIsEditModalOpen(true);
            break;

        case 'Edit':
            setEditType('Edit');
            setCompId(user.compId);
            setCompName(user.compName);
            setUserId(user.userId);
            setUserName(user.userName);
            setAuthorityId(user.authorityId);
            setGroupId(user.groupId || '');
            setIsEditModalOpen(true);
            break;

        case 'Add':
            setEditType('Add');
            setCompId('');
            setCompName('');
            setUserId('');
            setUserName('');
            setAuthorityId('');
            setGroupId('');            
            setIsEditModalOpen(true);
            break;
        
        default:
            console.log("不明な処理タイプです:", type);
            break;
        }

        console.log('user:',user)

    }; 

    const handleEditSave = async () => {
        // 確認ダイアログ
        const isConfirmed = window.confirm("この内容で保存しますか？");
        if (!isConfirmed) return;
        const uppayload = {
                id: `${compId}-${userId}`,
                compId: compId,
                compName: compName,
                userId: userId,
                userName: userName,
                authorityId: authorityId,
                groupId:groupId,
                container: "con-concierge-user"
        };
    
        try {
                // CosmosDBへの送信
                await SendToCosmos(uppayload);
                alert("保存が完了しました。");
        } catch (error) {
                console.error("保存中にエラーが発生しました：", error);
                alert("保存に失敗しました。");
        }
    
        // モーダルを閉じる
        await fetchUsers();
        setIsEditModalOpen(false);
    };
    
    const handleEditCancel = () => {
        console.log("保存処理を実行");
        setIsEditModalOpen(false);
    };
//削除
    const  handleDeleteClick = async　(user) => {
        const payload = {
            id: `${user.compId}-${user.userId}`,
            container: "con-concierge-user",
          };
        const isConfirmed = window.confirm("このユーザーを削除します。よろしいですか？");
        if (!isConfirmed) return;

        const result = await DeleteToCosmos(payload);
        alert(result);
        await fetchUsers();
    };

    return (
        <div>
                <Typography variant="h5" component="div" sx={{ color: '#1976d2', ml: 5 }}>
                    <ManageAccountsIcon /> ユーザー設定
                </Typography>
                <Box
                    sx={{
                        flex: 1,
                        bgcolor: 'white',
                        borderRadius: 2,
                        p: 3,
                        width: 'calc(95%)',
                        height: 'calc(100vh - 160px)',
                        margin: '0 20px',
                        overflow: 'auto'
                    }}
                >
                    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                        <Button variant="contained" startIcon={<PersonAddIcon />} color="primary"
                            onClick={() => handleEditClick("Add",{},'','')}
                        >
                            ユーザー追加
                        </Button>
                    </Box>
                    {/* ローディング中 */}
                    {loading ? (
                        <CircularProgress />
                    ) : (
                    <List dense>
                    <Divider />

                    {Object.keys(userList).map((compId, compIndex) => (
                        <React.Fragment key={compId}>
                        {compIndex !== 0 && <Divider />}

                        {/* 第1階層: 顧客 */}
                        <ListItem
                            dense
                            sx={{ py: 0.5, bgcolor: '#f5f5f5', cursor: 'pointer' }}
                            onClick={() => handleToggleCompany(compId)}
                        >
                            <ListItemText
                            primary={`顧客ID: ${compId}  ${userList[compId].compName}`}
                            slotProps={{
                                primary: { style: { fontSize: 14, fontWeight: 'bold' } }
                            }}
                            />

                            <IconButton
                            edge="end"
                            size="small"
                            sx={{ mr: 2 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleEditClick("AddCompany", {}, compId, userList[compId].compName, '');
                            }}
                            >
                            <PersonAddIcon fontSize="small" />
                            </IconButton>

                            {expandedCompanies[compId] ? (
                            <ExpandLessIcon fontSize="small" />
                            ) : (
                            <ExpandMoreIcon fontSize="small" />
                            )}
                        </ListItem>

                        <Divider />

                        {/* 第2階層: グループ */}
                        <Collapse in={expandedCompanies[compId]} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding dense>
                            {Object.keys(userList[compId].groups).map((groupId) => (
                                <React.Fragment key={`${compId}-${groupId}`}>
                                <ListItem
                                    dense
                                    sx={{ pl: 3, py: 0.4, bgcolor: '#fafafa', cursor: 'pointer' }}
                                    onClick={() => handleToggleGroup(compId, groupId)}
                                >
                                    <ListItemText
                                    primary={`グループ: ${groupId}`}
                                    slotProps={{
                                        primary: { style: { fontSize: 13 } }
                                    }}
                                    />

                                    <IconButton
                                    edge="end"
                                    size="small"
                                    sx={{ mr: 2 }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleEditClick("AddGroup", {}, compId, userList[compId].compName, groupId);
                                    }}
                                    >
                                    <PersonAddIcon fontSize="small" />
                                    </IconButton>

                                    {expandedGroups[`${compId}-${groupId}`] ? (
                                    <ExpandLessIcon fontSize="small" />
                                    ) : (
                                    <ExpandMoreIcon fontSize="small" />
                                    )}
                                </ListItem>

                                <Divider component="li" />

                                {/* 第3階層: ユーザー */}
                                <Collapse in={expandedGroups[`${compId}-${groupId}`]} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding dense>
                                    {userList[compId].groups[groupId].map((user) => (
                                        <React.Fragment key={user.userId}>
                                        <ListItem
                                            dense
                                            sx={{ pl: 6, py: 0.3 }}
                                        >
                                            <ListItemText
                                            primary={`ユーザーID: ${user.userId}  ${user.userName}`}
                                            slotProps={{
                                                primary: { style: { fontSize: 12 } }
                                            }}
                                            />

                                            <IconButton edge="end" size="small" onClick={(e) => {
                                                e.stopPropagation();
                                                handleEditClick("Edit", user, '', '', '');
                                            }}>
                                            <EditIcon fontSize="small" />
                                            </IconButton>

                                            <IconButton edge="end" size="small" onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteClick(user);
                                            }}>
                                            <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </ListItem>

                                        <Divider component="li" />
                                        </React.Fragment>
                                    ))}
                                    </List>
                                </Collapse>
                                </React.Fragment>
                            ))}
                            </List>
                        </Collapse>
                        </React.Fragment>
                    ))}
                    </List>
                    )}
                </Box>

            {/* 編集モーダル */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
                <Box sx={{ display: 'flex',flexDirection: 'column',p: 4, bgcolor: 'white', borderRadius: 2, margin: 'auto', mt: 10, width: '60%',height: '60%', }}>

                    <Typography variant="h6">ユーザー情報の編集</Typography>
                    <TextField
                        fullWidth
                        label="顧客ID"
                        value={compId}
                        onChange={(e) => setCompId(e.target.value)}
                        sx={{ mt: 2, width: '80%' }}
                        disabled={editType !== 'Add'}
                    />
                    <TextField
                        fullWidth
                        label="顧客名"
                        value={compName}
                        onChange={(e) => setCompName(e.target.value)}
                        sx={{ mt: 2 ,width: '80%' }}
                        disabled={editType !== 'Add'}
                    />
                    <TextField
                        fullWidth
                        label="ユーザーID"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                        sx={{ mt: 2,width: '80%'  }}
                        disabled={editType === 'Edit'}
                    />
                    <TextField
                        fullWidth
                        label="ユーザー名"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        sx={{ mt: 2 ,width: '80%' }}
                    />
                    <FormControl fullWidth sx={{ mt: 2 ,width: '80%' }}>
                        <InputLabel id="role-label">権限</InputLabel>
                        <Select
                            labelId="role-label"
                            value={authorityId}
                            label="権限"
                            onChange={(e) => setAuthorityId(e.target.value)}
                        >
                            {/* HQは本部と店舗のみ選択可能 */}
                            {loginInfo.authorityId === 'HQ' ? (
                                [
                                    <MenuItem key="HQ" value="HQ">本部</MenuItem>,
                                    <MenuItem key="store" value="store">店舗</MenuItem>
                                ]
                            ) : (
                                [
                                    <MenuItem key="admin" value="admin">管理者</MenuItem>,
                                    <MenuItem key="BU" value="BU">BU</MenuItem>,
                                    <MenuItem key="EMP" value="EMP">営業所</MenuItem>,
                                    <MenuItem key="HQ" value="HQ">本部</MenuItem>,
                                    <MenuItem key="store" value="store">店舗</MenuItem>
                                ]
                            )}
                        </Select>
                    </FormControl>

                    <TextField
                        fullWidth
                        label="グループ"
                        value={groupId}
                        onChange={(e) => setGroupId(e.target.value)}
                        sx={{ mt: 2 ,width: '80%' }}
                    />

                    <Box sx={{display: 'flex', gap: 2, mt: 2, justifyContent: 'flex-end'}}>
                        {editType === 'Edit' && (
                            <Button variant="contained" color="error" sx={{ mt: 2, width: '100px', mr: 'auto' }}
                                onClick={() => {
                                    handleDeleteClick({ compId, userId });
                                    setIsEditModalOpen(false);
                                }}
                            >
                                削除
                            </Button>
                        )}
                        <Button variant="contained" sx={{ mt: 2,width: '120px',backgroundColor: '#f8f8f8',
                            color: '#000','&:hover': {backgroundColor: '#d0d0d0',},
                         }} onClick={handleEditCancel}>
                            キャンセル
                        </Button>
                        <Button variant="contained" color="primary" sx={{ mt: 2,width: '100px' }} onClick={handleEditSave}>
                            保存
                        </Button>
                    </Box>
                </Box>
            </Modal>

        </div>
    );
};

export default SettingsUser;